import React from "react";
import { compose, withProps, withStateHandlers } from "recompose";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  InfoWindow
} from "react-google-maps";
import Loader from "../../common/loader/index";
import "./style.less";
const MapComponent = compose(
  withStateHandlers(
    () => ({
      isOpen: false
    }),
    {
      onToggleOpen: ({ isOpen }) => () => ({
        isOpen: !isOpen
      })
    }
  ),
  withProps({
    googleMapURL:
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyAEMPTYyEkHbs67oMSYS8Eq5_fOZXur0WQ&v=3.exp&libraries=geometry,drawing,places",
    loadingElement: <div style={{ height: "100%" }} />,
    containerElement: <div style={{ height: "500px", width: "100%" }} />,
    mapElement: <div style={{ height: "100%" }} />
  }),
  withScriptjs,
  withGoogleMap
)(props => (
  <GoogleMap zoom={4} center={props.location}>
    {props.propertyList &&
      (props.propertyList || []).map((propertyInfo, index) => (
        <Marker
          key={"Marker" + index}
          position={{
            lat: Number.parseInt(propertyInfo.lattitude),
            lng: Number.parseInt(propertyInfo.longitude)
          }}
          onClick={index => {
            props.onToggleOpen();
            props.handleSelectedMarker(index);
          }}
        >
          {props.selectedMarker == index && (
            <InfoWindow
              onCloseClick={() => {
                props.onToggleOpen, props.handleSelectedMarker(-1);
              }}
            >
              <div>
                <div className={"info-header"}>{propertyInfo.name}</div>
                <div className={"info-address"}>{props.address}</div>
                <div className={"info-market"}>
                  {(propertyInfo.city ? propertyInfo.state + "|" : "") +
                    propertyInfo.zip || ""}{" "}
                </div>
                <div>
                  <a
                    target={"_blank"}
                    rel={"noreferrer"}
                    href={
                      "https://www.google.com/maps/@" +
                      propertyInfo.lattitude +
                      "," +
                      propertyInfo.longitude +
                      ",15z?hl=en-US"
                    }
                  >
                    {"View on google map.\r"}
                  </a>
                </div>
              </div>
            </InfoWindow>
          )}
        </Marker>
      ))}
  </GoogleMap>
));

class PropertyMapComponent extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showMarker: false,
    };
  }

  /**
   * onload event
   */
  componentDidMount() {
    this.setState({
      showMarker: true
    });
  }

  /**
   * onload event
   */
  handleMarkerClick = () => {
    // this.setState({ showMarkerInfo: true });
  };

  /**
   * update comment as per functionality (for devloper)
   */
  handleSelectedMarker = () => {
    // this.setState({ selectedMarker: index });
  };

  /**
   * update comment as per functionality (for devloper)
   */
  hideMarkerInfo = () => {
    // this.setState({ showMarkerInfo: false });
  };

  render() {
    const { propertyList } = this.props;
    return (
      <>
        {propertyList != null ? (
          <MapComponent
            showMarker={this.state.showMarker}
            location={{
              lat: this.props.propertyList[0].lattitude,
              lng: this.props.propertyList[0].longitude
            }}
            propertyList={propertyList}
            onMarkerClick={this.handleMarkerClick}
            hideMarkerInfo={this.hideMarkerInfo}
            handleSelectedMarker={this.handleSelectedMarker}
          />
        ) : (
          <Loader loading />
        )}
      </>
    );
  }
}
export default PropertyMapComponent;
